export default __webpack_public_path__ + "static/media/logo.c13301b3.png";